/**
 * Fast Simon upsell — mobile sticky product form behavior (native JS).
 * Migrated from LIVE custom.js jQuery scroll handler.
 */
(function () {
  function getScrollTop() {
    return window.scrollY || document.documentElement.scrollTop;
  }

  function getOffsetTop(element) {
    return element.getBoundingClientRect().top + getScrollTop();
  }

  function hideStickyForm(productForm) {
    if (!productForm.classList.contains('newFormClass')) return;
    productForm.classList.add('is-leaving');
    setTimeout(function () {
      productForm.classList.remove('newFormClass', 'is-leaving');
    }, 200);
  }

  var footerInView = false;

  var footer = document.querySelector('footer');
  if (footer) {
    var footerObserver = new IntersectionObserver(function (entries) {
      footerInView = entries[0].isIntersecting;
      handleFastSimonProductScroll();
    }, { threshold: 0, rootMargin: '0px 0px 0px 0px' });

    footerObserver.observe(footer);
  }

  function handleFastSimonProductScroll() {
    var scrollTop = getScrollTop();
    var mobileSticky = document.querySelector('.mobile_sticky');
    var productForm = document.querySelector('[data-product-form]');
    var fsUpsell = document.querySelector('[class*="fast-simon-upsell-"]');

    if (mobileSticky) {
      if (scrollTop > 150 && !footerInView) {
        if (mobileSticky.classList.contains('Open_Crown_Product')) {
          mobileSticky.classList.remove('newClass');
        } else {
          mobileSticky.classList.add('newClass');
        }
      } else {
        mobileSticky.classList.remove('newClass');
      }
    }

    if (fsUpsell && productForm) {
      var upsellTop = getOffsetTop(fsUpsell);

      if (scrollTop > upsellTop && !footerInView) {
        if (mobileSticky && mobileSticky.classList.contains('Open_Crown_Product')) {
          hideStickyForm(productForm);
        } else {
          productForm.classList.add('newFormClass');
        }
      } else {
        hideStickyForm(productForm);
      }
    }
  }

  window.addEventListener('scroll', handleFastSimonProductScroll, { passive: true });

})();


// Datalayer event on view of the step on team-roper-bundle-builder page
(function () {
  var lastStepViewed = null;
  var observerInitialized = false;

  function getActiveStep() {
    var activeTab = document.querySelector('.rebuy-bundle-builder__step-tab.active');
    if (!activeTab) return null;

    var match = activeTab.className.match(/step-tab-(\d+)/);
    if (match) {
      return parseInt(match[1]) + 1;
    }
    return null;
  }

  function sendStepViewedEvent(stepNumber) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'step_viewed',
      step_number: String(stepNumber)
    });
  }

  function initObserver() {
    var container = document.querySelector('.rebuy-bundle-builder__step-tabs-wrapper');
    if (!container || observerInitialized) return;

    observerInitialized = true;

    var observer = new MutationObserver(function () {
      var currentStep = getActiveStep();
      if (currentStep && currentStep !== lastStepViewed) {
        lastStepViewed = currentStep;
        sendStepViewedEvent(currentStep);
      }
    });

    observer.observe(container, {
      attributes: true,
      subtree: true,
      attributeFilter: ['class']
    });

    var initialStep = getActiveStep();
    if (initialStep) {
      lastStepViewed = initialStep;
      sendStepViewedEvent(initialStep);
    }
  }

  var interval = setInterval(function () {
    if (document.querySelector('.rebuy-bundle-builder__step-tabs-wrapper')) {
      clearInterval(interval);
      initObserver();
    }
  }, 500);

  setTimeout(function () {
    clearInterval(interval);
  }, 10000);
})();

  /* step_add_to_cart */
  (function () {
    var priceIndexByCard = new WeakMap();

    function indexVisibleCards() {
      document
        .querySelectorAll('.rebuy-bundle-builder__product, .rebuy-product')
        .forEach(function (card) {
          var name = extractName(card);
          var price = extractPrice(card);
          if (!name && !price) return;

          priceIndexByCard.set(card, { item_name: name, item_price: price });
        });
    }

    indexVisibleCards();
    var indexInterval = setInterval(indexVisibleCards, 800);

    function getStepNumber() {
      var active =
        document.querySelector(
          '[class*="rebuy-bundle-builder__step-container-"].rebuy-bundle-builder__step-container--active'
        ) ||
        document.querySelector('[class*="rebuy-bundle-builder__step-container-"].active');
      if (!active) return '';
      var match = active.className.match(/step-container-(\d+)/);
      return match ? String(parseInt(match[1], 10) + 1) : '';
    }

    function onAddClickCapture(e) {
      var btn = e.target.closest('button.rebuy-button');
      if (!btn) return;

      if (btn.closest('.rebuy-bundle-builder__summary, .rebuy-bundle-builder__footer')) return;

      var priceContainer = btn
        .closest('.rebuy-bundle-builder__product-quantity')
        ?.closest('.rebuy-product-actions')
        ?.closest('.rebuy-bundle-builder__step-product');

      var itemPrice = null;
      if (priceContainer) {
        var priceSpans = priceContainer.querySelectorAll('.rebuy-money span');
        if (priceSpans.length > 1) {
          itemPrice = priceSpans[1].textContent.trim().replace(/\$/g, '');
        }
      }

      var card = btn.closest('.rebuy-bundle-builder__product, .rebuy-product');
      var itemName = null;

      if (card) {
        var cached = priceIndexByCard.get(card);
        itemName = cached ? cached.item_name || null : extractName(card);
        if (!itemPrice && cached) {
          itemPrice = cached.item_price || null;
        }
      }

      if (!itemName) {
        var ariaLabel = btn.getAttribute('aria-label') || '';
        var nameMatch = ariaLabel.match(/Add (?:the )?product,\s*(.*?)\s*(?:to Cart|$)/i);
        if (nameMatch) itemName = nameMatch[1].trim();
      }

      window.dataLayer.push({
        event: 'step_add_to_cart',
        step_number: getStepNumber(),
        item_name: itemName,
        item_price: itemPrice
      });
    }

    document.addEventListener('click', onAddClickCapture, true);

    setTimeout(function () {
      clearInterval(indexInterval);
    }, 120000);
  })();

  /* bulk_add_to_cart */
  (function () {
    function getStepsCompleted() {
      var completed = document.querySelectorAll(
        '.rebuy-bundle-builder__step-container.active, .rebuy-bundle-builder__step-container--active, .rebuy-bundle-builder__step-container.completed'
      );
      return completed.length || null;
    }

    function getItemsAdded() {
      var addedProducts = document.querySelectorAll('.rebuy-bundle-builder__product-holder-data');
      return addedProducts.length || null;
    }

    function getCartTotal() {
      var btn = document.querySelector(
        '.rebuy-bundle-builder__group-container-action .rebuy-button, .rebuy-bundle-builder__cta-container .rebuy-button'
      );
      if (btn) {
        var text = btn.textContent || '';
        var match = text.match(/(\d+(?:\.\d{1,2})?)/);
        if (match) return match[1];
      }

      var totalEl = document.querySelector(
        '.rebuy-bundle-builder__summary, .rebuy-bundle-builder__group-container-total, [class*="bundle-total"]'
      );
      if (totalEl) {
        var clean = totalEl.textContent.replace(/[^0-9.]/g, '');
        if (clean) return clean;
      }

      return null;
    }

    function handleBulkAddClick(e) {
      var btn = e.target.closest(
        '.rebuy-bundle-builder__group-container-action .rebuy-button, .rebuy-bundle-builder__cta-container .rebuy-button'
      );
      if (!btn) return;

      var cartTotal = getCartTotal();

      window.dataLayer.push({
        event: 'bulk_add_to_cart',
        steps_completed: String(getStepsCompleted()),
        items_added: String(getItemsAdded()),
        cart_total: cartTotal ? parseFloat(cartTotal) : null
      });
    }

    var interval = setInterval(function () {
      if (
        document.querySelector(
          '.rebuy-bundle-builder__group-container-action .rebuy-button, .rebuy-bundle-builder__cta-container .rebuy-button'
        )
      ) {
        clearInterval(interval);
        document.body.addEventListener('click', handleBulkAddClick, true);
      }
    }, 500);

    setTimeout(function () {
      clearInterval(interval);
    }, 10000);
  })();

/**
 * Collapsible product description behavior.
 */
(function () {
  function initCollapsibleDescriptions() {
    var descriptions = document.querySelectorAll('[data-product-description][data-read-more="true"]');
    descriptions.forEach(function (desc) {
      if (desc.dataset.collapsibleInitialized === 'true') return;
      desc.dataset.collapsibleInitialized = 'true';

      var maxWords = parseInt(desc.dataset.readMoreWordLimit, 10) || 60;
      desc.dataset.originalHtml = desc.innerHTML;

      function getWordCount(el) {
        var text = el.textContent || el.innerText || '';
        return text.trim().split(/\s+/).filter(Boolean).length;
      }

      function truncateHtml(element, limit) {
        var wordCount = 0;
        var limitReached = false;

        function traverse(node) {
          if (limitReached) {
            node.parentNode.removeChild(node);
            return;
          }

          if (node.nodeType === Node.TEXT_NODE) {
            var words = node.textContent.trim().split(/\s+/).filter(Boolean);
            var nodeWordCount = words.length;

            if (wordCount + nodeWordCount >= limit) {
              var remainingWords = limit - wordCount;
              var truncatedText = words.slice(0, remainingWords).join(' ') + '...';
              node.textContent = truncatedText;

              wordCount = limit;
              limitReached = true;
            } else {
              wordCount += nodeWordCount;
            }
          } else if (node.nodeType === Node.ELEMENT_NODE) {
            var childNodes = Array.from(node.childNodes);
            for (var i = 0; i < childNodes.length; i++) {
              traverse(childNodes[i]);
            }
            if (limitReached && node.childNodes.length === 0) {
              node.parentNode.removeChild(node);
            }
          }
        }

        traverse(element);

        // Append 'See More' link directly to the truncated container
        var link = document.createElement('a');
        link.href = '#';
        link.className = 'product-description-toggle-link';
        link.innerHTML = 'See More';
        element.appendChild(link);
      }

      var totalWords = getWordCount(desc);
      if (totalWords > maxWords) {
        truncateHtml(desc, maxWords);

        desc.addEventListener('click', function (e) {
          var target = e.target;
          if (target && target.classList.contains('product-description-toggle-link')) {
            e.preventDefault();
            var isExpanded = desc.classList.contains('is-expanded');

            if (isExpanded) {
              desc.classList.remove('is-expanded');
              desc.innerHTML = desc.dataset.originalHtml;
              truncateHtml(desc, maxWords);

              var rect = desc.getBoundingClientRect();
              if (rect.top < 0) {
                window.scrollTo({
                  top: window.scrollY + rect.top - 20,
                  behavior: 'smooth'
                });
              }
            } else {
              desc.classList.add('is-expanded');
              desc.innerHTML = desc.dataset.originalHtml;

              var link = document.createElement('a');
              link.href = '#';
              link.className = 'product-description-toggle-link';
              link.innerHTML = 'See Less';

              desc.appendChild(link);
            }
          }
        });
      }
    });
  }

  // Bind to standard page load events
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollapsibleDescriptions);
  } else {
    initCollapsibleDescriptions();
  }

  // Re-run checking for dynamic or lazy-loaded descriptions
  window.addEventListener('load', initCollapsibleDescriptions);

  // Bind to Theme Editor load/select changes
  document.addEventListener('shopify:section:load', initCollapsibleDescriptions);
  document.addEventListener('shopify:block:load', initCollapsibleDescriptions);
  document.addEventListener('shopify:block:select', initCollapsibleDescriptions);
})();
(function () {
  function getChatButton() {
    var host = document.getElementById('fast-simon-chatbot');
    if (host && host.shadowRoot) {
      return host.shadowRoot.getElementById('open-chat-button');
    }
    return null;
  }

  function positionBackToTop() {
    var chatBtn = getChatButton();
    var backToTop = document.querySelector('.back-to-top');
    if (!chatBtn || !backToTop) return false;

    if (window.innerWidth >= 860) {
      var rect = chatBtn.getBoundingClientRect();
      var rightOffset = window.innerWidth - rect.left + 16;
      backToTop.style.right = rightOffset + 'px';
    } else {
      backToTop.style.right = '';
    }
    return true;
  }

  positionBackToTop();

  var attempts = 0;
  var pollInterval = setInterval(function () {
    attempts++;
    if (positionBackToTop() || attempts > 20) {
      clearInterval(pollInterval);
    }
  }, 250);

  window.addEventListener('load', positionBackToTop);
  window.addEventListener('resize', positionBackToTop);
})();
